import { useCart } from '../../context/CartContext';
import './Cart.css';

function CartIcon({ onClick }) {
  const { cartCount } = useCart();

  return (
    <button className="cart-icon" onClick={onClick} aria-label="Shopping cart">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </svg>
      {cartCount > 0 && <span className="cart-icon__badge">{cartCount}</span>}
    </button>
  );
}

export default CartIcon;
